import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { mockTasks } from '../../data/mockData';

export default function ScheduleView() {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-6 pb-20 md:pb-6 max-w-4xl mx-auto"
    >
      <div className="flex justify-between items-end border-b border-garden-base pb-4">
        <div>
          <h2 className="text-2xl font-bold text-clay">Rhythm Sync</h2>
          <p className="text-sm text-clay-muted">Chronological task execution protocol.</p>
        </div>
        <div className="text-right">
          <p className="text-xs font-mono text-clay-dark">CURRENT CYCLE</p>
          <p className="text-lime font-mono">DAY 142</p>
        </div>
      </div>

      <div className="space-y-8">
        {/* Today */}
        <div>
          <h3 className="text-sm font-mono text-clay-dark mb-4 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-lime animate-pulse"></span>
            IMMEDIATE ACTION REQUIRED
          </h3>
          <div className="space-y-3">
            {mockTasks.filter(t => t.time.includes('AM') || t.time.includes('PM')).map(task => (
              <div key={task.id} className="glass-panel p-4 rounded-lg flex items-center gap-4 group hover:bg-garden-base/30 transition-colors">
                <div className="flex-shrink-0 w-12 text-center">
                  <p className="text-xs font-mono text-lime">{task.time.split(' ')[0]}</p>
                  <p className="text-[10px] font-mono text-clay-dark">{task.time.split(' ')[1]}</p>
                </div>
                <div className="w-px h-8 bg-garden-base"></div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-clay">{task.title}</p>
                  <p className="text-xs text-clay-muted capitalize flex items-center gap-1 mt-1">
                    <SafeIcon icon={task.type === 'water' ? 'Droplet' : task.type === 'harvest' ? 'Scissors' : 'Activity'} className="text-[10px]" />
                    {task.type} Protocol
                  </p>
                </div>
                <button className="w-8 h-8 rounded-full border border-garden-base flex items-center justify-center text-clay-dark hover:border-lime hover:text-lime transition-all">
                  <SafeIcon icon="Check" />
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Upcoming */}
        <div>
          <h3 className="text-sm font-mono text-clay-dark mb-4">PENDING CYCLES</h3>
          <div className="space-y-3 opacity-70">
            {mockTasks.filter(t => !t.time.includes('AM') && !t.time.includes('PM')).map(task => (
              <div key={task.id} className="bg-garden-dark p-4 rounded-lg border border-garden-base flex items-center gap-4">
                <div className="flex-shrink-0 w-24">
                  <p className="text-xs font-mono text-clay-muted">{task.time}</p>
                </div>
                <div className="w-px h-8 bg-garden-base"></div>
                <div className="flex-1">
                  <p className="text-sm text-clay">{task.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
}